import {Units} from '../../../../components/Forms/Constants/CommonESGConstants/constants';
import {
  CSRDetailsKey,
  CSRDetailsLabel,
  DetailsOfTheListedEntityKey,
  DetailsOfTheListedEntityLabel,
  EmployeesKey,
  EmployeesLabel,
  HoldingSubsidiaryAndAssociateCompaniesKey,
  HoldingSubsidiaryAndAssociateCompaniesLabel,
  OperationsKey,
  OperationsLabel,
  ProductsServicesKey,
  ProductsServicesLabel,
  TransparencyAndDisclosuresCompliancesKey,
  TransparencyAndDisclosuresCompliancesLabel
} from '../../../../components/Forms/Constants/GeneralDisclosure/QuestionsKeyLabel';
import {inputType} from '../../interface/inputType';
import {calculateSum} from '../commonFunctions';

/* eslint-disable max-len */
export const detailsOfTheListedEntityTabQuestions = [
  {
    key: '1',
    items: [
      {
        question: 'Corporate Identity Number (CIN) of the Listed Entity :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_1,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_1,
            convertToUpperCase: true
          }
        ]
      },
      {
        question: 'Name of the Listed Entity :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_2,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_2
          }
        ]
      },
      {
        question: 'Year of incorporation :',
        field: [
          {
            fieldType: inputType.DATEPICKER,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_3,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_3,
            restrictFutureDateSelection: true,
            dateFormat: 'YYYY',
            pickerType: 'year'
          }
        ]
      },
      {
        question: 'Registered office address :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_4,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_4
          }
        ]
      },
      {
        question: 'Corporate address :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_5,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_5
          }
        ]
      },
      {
        question: 'E-mail :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_6,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_6
          }
        ]
      },
      {
        question: 'Telephone :',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_7,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_7,
            isFormatted: false
          }
        ]
      },
      {
        question: 'Website :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_8,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_8
          }
        ]
      },
      {
        question: 'Financial year for which reporting is being done :',
        field: [
          {
            fieldType: inputType.DATE_RANGE_PICKER,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_9,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_9,
            disabled: true,
            restrictFutureDateSelection: true,
            dateFormat: 'DD-MM-YYYY',
            useSelectedYear: true
          }
        ]
      },
      {
        question: 'Name of the Stock Exchange(s) where shares are listed :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_10,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_10
          }
        ]
      },
      {
        question: 'Paid-up Capital :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_11,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_11
          }
        ]
      },
      {
        question:
          'Name  and  contact  details  (telephone,  email  address)  of  the  person  who  may  be contacted in case of any queries on the BRSR report :',
        field: [
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_12,
                  fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_12
                },
                {
                  type: inputType.TEXT,
                  fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_21,
                  fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_18
                },
                {
                  type: inputType.NUMBER,
                  fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_13,
                  fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_13,
                  isFormatted: false
                },
                {
                  type: inputType.TEXT,
                  fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_14,
                  fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_14
                }
              ]
            }
          }
        ]
      },
      {
        question:
          'Reporting boundary - Are the disclosures under this report made on a standalone basis (i.e. only for the entity) or on a consolidated basis (i.e. for the entity and all the entities which form a part of its consolidated financial statements, taken together) :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_15,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_15
          }
        ]
      },
      {
        question: 'Name of assurance provider :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_16,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_16
          }
        ]
      },
      {
        question: 'Type of assurance obtained :',
        field: [
          {
            fieldType: inputType.TEXT,
            fieldName: DetailsOfTheListedEntityKey.DOLE_QUESTION_17,
            fieldLabel: DetailsOfTheListedEntityLabel.DOLE_QUESTION_17
          }
        ]
      }
    ]
  }
];

export const productsServicesTabQuestions = [
  {
    key: '1',
    label: ProductsServicesLabel.PS_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: ProductsServicesKey.PS_QUESTION_13,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: ProductsServicesKey.PS_QUESTION_1,
                  fieldLabel: ProductsServicesLabel.PS_HEADING_4,
                  placeHolder: 'Description of Main Activity',
                  colSpan: true
                },
                {
                  type: inputType.TEXT,
                  fieldName: ProductsServicesKey.PS_QUESTION_2,
                  fieldLabel: ProductsServicesLabel.PS_HEADING_5,
                  placeHolder: 'Description of Business Activity',
                  colSpan: true
                },
                {
                  type: inputType.PERCENTAGE,
                  fieldName: ProductsServicesKey.PS_QUESTION_3,
                  fieldLabel: ProductsServicesLabel.PS_HEADING_6,
                  placeHolder: '% of Turnover of the entity',
                  units: Units.percentage,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: ProductsServicesLabel.PS_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName: ProductsServicesKey.PS_QUESTION_14,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName: ProductsServicesKey.PS_QUESTION_4,
                  fieldLabel: ProductsServicesLabel.PS_HEADING_1,
                  placeHolder: 'Product / Service',
                  colSpan: true
                },
                {
                  type: inputType.TEXT,
                  fieldName: ProductsServicesKey.PS_QUESTION_5,
                  fieldLabel: ProductsServicesLabel.PS_HEADING_2,
                  placeHolder: 'NIC Code',
                  colSpan: true
                },
                {
                  type: inputType.PERCENTAGE,
                  fieldName: ProductsServicesKey.PS_QUESTION_6,
                  fieldLabel: ProductsServicesLabel.PS_HEADING_3,
                  placeHolder: '% of total Turnover contributed',
                  units: Units.percentage,
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const operationsTabQuestions = [
  {
    key: '1',
    label: OperationsLabel.O_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: OperationsKey.O_QUESTION_1,
                  fieldLabel: OperationsLabel.O_QUESTION_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: OperationsKey.O_QUESTION_2,
                  fieldLabel: OperationsLabel.O_QUESTION_2
                },

                {
                  type: inputType.NUMBER_COL,
                  fieldName: OperationsKey.O_QUESTION_3,
                  fieldLabel: OperationsLabel.O_QUESTION_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: OperationsKey.O_QUESTION_4,
                  fieldLabel: OperationsLabel.O_QUESTION_4
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: OperationsKey.O_QUESTION_11,
                  fieldLabel: OperationsLabel.O_QUESTION_5,
                  relatedKey: [
                    OperationsKey.O_QUESTION_1,
                    OperationsKey.O_QUESTION_2
                  ],
                  formula: calculateSum
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: OperationsKey.O_QUESTION_12,
                  fieldLabel: OperationsLabel.O_QUESTION_6,
                  relatedKey: [
                    OperationsKey.O_QUESTION_3,
                    OperationsKey.O_QUESTION_4
                  ],
                  formula: calculateSum
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: OperationsLabel.O_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING,
            heading: OperationsLabel.O_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OperationsKey.O_QUESTION_5,
            fieldLabel: OperationsLabel.O_QUESTION_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OperationsKey.O_QUESTION_6,
            fieldLabel: OperationsLabel.O_QUESTION_8
          },
          {
            fieldType: inputType.PERCENTAGE,
            fieldName: OperationsKey.O_QUESTION_7,
            fieldLabel: OperationsLabel.O_HEADING_2,
            heading: inputType.HEADING,
            colSpan: true,
            units: Units.percentage
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OperationsKey.O_QUESTION_8,
            fieldLabel: OperationsLabel.O_HEADING_3,
            heading: inputType.HEADING,
            colSpan: true,
            askAIkey: 'OPS_CUST_TYPES'
          }
        ]
      }
    ]
  }
];

export const employeesTabQuestions = [
  {
    key: '1',
    label: EmployeesLabel.E_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: EmployeesLabel.E_HEADING_1
          },
          {
            fieldType: inputType.HEADING_3,
            heading: EmployeesLabel.E_HEADING_2
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_1,
                  fieldLabel: EmployeesLabel.E_QUESTION_1
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_2,
                  fieldLabel: EmployeesLabel.E_QUESTION_2
                },

                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_3,
                  fieldLabel: EmployeesLabel.E_QUESTION_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_4,
                  fieldLabel: EmployeesLabel.E_QUESTION_4
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_43,
                  fieldLabel: EmployeesLabel.E_HEADING_3,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_1,
                    EmployeesKey.E_QUESTION_2
                  ],
                  formula: calculateSum
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_44,
                  fieldLabel: EmployeesLabel.E_HEADING_4,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_3,
                    EmployeesKey.E_QUESTION_4
                  ],
                  formula: calculateSum
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_45,
                  fieldLabel: EmployeesLabel.E_HEADING_5,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_1,
                    EmployeesKey.E_QUESTION_2,
                    EmployeesKey.E_QUESTION_3,
                    EmployeesKey.E_QUESTION_4
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const totalEmployees = totalMale + totalFemale;
                    const permanent = permaMale + permaFemale;

                    return totalEmployees - permanent;
                  }
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_46,
                  fieldLabel: EmployeesLabel.E_HEADING_6,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_3,
                    EmployeesKey.E_QUESTION_4
                  ],
                  formula: ([permaMale, permaFemale]: any[]):
                    | number
                    | string => {
                    return (permaMale / (permaMale + permaFemale)) * 100 || 0;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_47,
                  fieldLabel: EmployeesLabel.E_HEADING_7,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_3,
                    EmployeesKey.E_QUESTION_4
                  ],
                  formula: ([permaMale, permaFemale]: any[]):
                    | number
                    | string => {
                    return (permaFemale / (permaMale + permaFemale)) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_71,
                  fieldLabel: EmployeesLabel.E_HEADING_22,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_1,
                    EmployeesKey.E_QUESTION_3
                  ],
                  formula: ([totalMale, permaMale]: any[]): number | string => {
                    return totalMale - permaMale;
                  }
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_72,
                  fieldLabel: EmployeesLabel.E_HEADING_23,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_2,
                    EmployeesKey.E_QUESTION_4
                  ],
                  formula: ([totalFemale, permaFemale]: any[]):
                    | number
                    | string => {
                    return totalFemale - permaFemale;
                  }
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_73,
                  fieldLabel: EmployeesLabel.E_HEADING_24,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_1,
                    EmployeesKey.E_QUESTION_2,
                    EmployeesKey.E_QUESTION_3,
                    EmployeesKey.E_QUESTION_4
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const otherMale = totalMale - permaMale;
                    const otherFemale = totalFemale - permaFemale;
                    const totalOther = otherMale + otherFemale;

                    return (otherMale / totalOther) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_74,
                  fieldLabel: EmployeesLabel.E_HEADING_25,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_1,
                    EmployeesKey.E_QUESTION_2,
                    EmployeesKey.E_QUESTION_3,
                    EmployeesKey.E_QUESTION_4
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const otherMale = totalMale - permaMale;
                    const otherFemale = totalFemale - permaFemale;
                    const totalOther = otherMale + otherFemale;

                    return (otherFemale / totalOther) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_75,
                  fieldLabel: EmployeesLabel.E_HEADING_26,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_1,
                    EmployeesKey.E_QUESTION_2
                  ],
                  formula: ([totalMale, totalFemale]: any[]):
                    | number
                    | string => {
                    const total = totalMale + totalFemale;

                    return (totalMale / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_76,
                  fieldLabel: EmployeesLabel.E_HEADING_27,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_1,
                    EmployeesKey.E_QUESTION_2
                  ],
                  formula: ([totalMale, totalFemale]: any[]):
                    | number
                    | string => {
                    const total = totalMale + totalFemale;

                    return (totalFemale / total) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: EmployeesLabel.E_HEADING_8
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_5,
                  fieldLabel: EmployeesLabel.E_QUESTION_5
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_6,
                  fieldLabel: EmployeesLabel.E_QUESTION_6
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_7,
                  fieldLabel: EmployeesLabel.E_QUESTION_7
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_8,
                  fieldLabel: EmployeesLabel.E_QUESTION_8
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_48,
                  fieldLabel: EmployeesLabel.E_HEADING_9,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_5,
                    EmployeesKey.E_QUESTION_6
                  ],
                  formula: calculateSum
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_49,
                  fieldLabel: EmployeesLabel.E_HEADING_10,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_7,
                    EmployeesKey.E_QUESTION_8
                  ],
                  formula: calculateSum
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_50,
                  fieldLabel: EmployeesLabel.E_HEADING_11,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_5,
                    EmployeesKey.E_QUESTION_6,
                    EmployeesKey.E_QUESTION_7,
                    EmployeesKey.E_QUESTION_8
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const totalEmployees = totalMale + totalFemale;
                    const permanent = permaMale + permaFemale;

                    return totalEmployees - permanent;
                  }
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_51,
                  fieldLabel: EmployeesLabel.E_HEADING_12,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_7,
                    EmployeesKey.E_QUESTION_8
                  ],
                  formula: ([permaMale, permaFemale]: any[]):
                    | number
                    | string => {
                    return (permaMale / (permaMale + permaFemale)) * 100 || 0;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_52,
                  fieldLabel: EmployeesLabel.E_HEADING_13,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_7,
                    EmployeesKey.E_QUESTION_8
                  ],
                  formula: ([permaMale, permaFemale]: any[]):
                    | number
                    | string => {
                    return (permaFemale / (permaMale + permaFemale)) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_77,
                  fieldLabel: EmployeesLabel.E_HEADING_28,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_5,
                    EmployeesKey.E_QUESTION_7
                  ],
                  formula: ([totalMale, permaMale]: any[]): number | string => {
                    return totalMale - permaMale;
                  }
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_78,
                  fieldLabel: EmployeesLabel.E_HEADING_29,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_6,
                    EmployeesKey.E_QUESTION_8
                  ],
                  formula: ([totalFemale, permaFemale]: any[]):
                    | number
                    | string => {
                    return totalFemale - permaFemale;
                  }
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_79,
                  fieldLabel: EmployeesLabel.E_HEADING_30,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_5,
                    EmployeesKey.E_QUESTION_6,
                    EmployeesKey.E_QUESTION_7,
                    EmployeesKey.E_QUESTION_8
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const otherMale = totalMale - permaMale;
                    const otherFemale = totalFemale - permaFemale;
                    const totalOther = otherMale + otherFemale;

                    return (otherMale / totalOther) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_80,
                  fieldLabel: EmployeesLabel.E_HEADING_31,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_5,
                    EmployeesKey.E_QUESTION_6,
                    EmployeesKey.E_QUESTION_7,
                    EmployeesKey.E_QUESTION_8
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const otherMale = totalMale - permaMale;
                    const otherFemale = totalFemale - permaFemale;
                    const totalOther = otherMale + otherFemale;

                    return (otherFemale / totalOther) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_81,
                  fieldLabel: EmployeesLabel.E_HEADING_32,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_5,
                    EmployeesKey.E_QUESTION_6
                  ],
                  formula: ([totalMale, totalFemale]: any[]):
                    | number
                    | string => {
                    const total = totalMale + totalFemale;

                    return (totalMale / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_82,
                  fieldLabel: EmployeesLabel.E_HEADING_33,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_5,
                    EmployeesKey.E_QUESTION_6
                  ],
                  formula: ([totalMale, totalFemale]: any[]):
                    | number
                    | string => {
                    const total = totalMale + totalFemale;

                    return (totalFemale / total) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: EmployeesLabel.E_HEADING_14
          },
          {
            fieldType: inputType.HEADING_3,
            heading: EmployeesLabel.E_HEADING_15
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_9,
                  fieldLabel: EmployeesLabel.E_QUESTION_9
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_10,
                  fieldLabel: EmployeesLabel.E_QUESTION_10
                },

                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_11,
                  fieldLabel: EmployeesLabel.E_QUESTION_11
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_12,
                  fieldLabel: EmployeesLabel.E_QUESTION_12
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_53,
                  fieldLabel: EmployeesLabel.E_HEADING_3,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_9,
                    EmployeesKey.E_QUESTION_10
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_54,
                  fieldLabel: EmployeesLabel.E_HEADING_4,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_11,
                    EmployeesKey.E_QUESTION_12
                  ],
                  formula: calculateSum
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_55,
                  fieldLabel: EmployeesLabel.E_HEADING_5,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_9,
                    EmployeesKey.E_QUESTION_10,
                    EmployeesKey.E_QUESTION_11,
                    EmployeesKey.E_QUESTION_12
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const totalEmployees = totalMale + totalFemale;
                    const permanent = permaMale + permaFemale;

                    return totalEmployees - permanent;
                  }
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_56,
                  fieldLabel: EmployeesLabel.E_HEADING_6,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_11,
                    EmployeesKey.E_QUESTION_12
                  ],
                  formula: ([permaMale, permaFemale]: any[]):
                    | number
                    | string => {
                    return (permaMale / (permaMale + permaFemale)) * 100 || 0;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_57,
                  fieldLabel: EmployeesLabel.E_HEADING_7,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_11,
                    EmployeesKey.E_QUESTION_12
                  ],
                  formula: ([permaMale, permaFemale]: any[]):
                    | number
                    | string => {
                    return (permaFemale / (permaMale + permaFemale)) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_96,
                  fieldLabel: EmployeesLabel.E_HEADING_22,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_9,
                    EmployeesKey.E_QUESTION_11
                  ],
                  formula: ([totalMale, permaMale]: any[]): number | string => {
                    return totalMale - permaMale;
                  }
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_97,
                  fieldLabel: EmployeesLabel.E_HEADING_23,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_10,
                    EmployeesKey.E_QUESTION_12
                  ],
                  formula: ([totalFemale, permaFemale]: any[]):
                    | number
                    | string => {
                    return totalFemale - permaFemale;
                  }
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_98,
                  fieldLabel: EmployeesLabel.E_HEADING_24,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_9,
                    EmployeesKey.E_QUESTION_10,
                    EmployeesKey.E_QUESTION_11,
                    EmployeesKey.E_QUESTION_12
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const otherMale = totalMale - permaMale;
                    const otherFemale = totalFemale - permaFemale;
                    const totalOther = otherMale + otherFemale;

                    return (otherMale / totalOther) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_99,
                  fieldLabel: EmployeesLabel.E_HEADING_25,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_9,
                    EmployeesKey.E_QUESTION_10,
                    EmployeesKey.E_QUESTION_11,
                    EmployeesKey.E_QUESTION_12
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const otherMale = totalMale - permaMale;
                    const otherFemale = totalFemale - permaFemale;
                    const totalOther = otherMale + otherFemale;

                    return (otherFemale / totalOther) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_88,
                  fieldLabel: EmployeesLabel.E_HEADING_26,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_9,
                    EmployeesKey.E_QUESTION_10
                  ],
                  formula: ([totalMale, totalFemale]: any[]):
                    | number
                    | string => {
                    const total = totalMale + totalFemale;

                    return (totalMale / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_89,
                  fieldLabel: EmployeesLabel.E_HEADING_27,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_9,
                    EmployeesKey.E_QUESTION_10
                  ],
                  formula: ([totalMale, totalFemale]: any[]):
                    | number
                    | string => {
                    const total = totalMale + totalFemale;

                    return (totalFemale / total) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: EmployeesLabel.E_HEADING_16
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_13,
                  fieldLabel: EmployeesLabel.E_QUESTION_13
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_14,
                  fieldLabel: EmployeesLabel.E_QUESTION_14
                },

                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_15,
                  fieldLabel: EmployeesLabel.E_QUESTION_15
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_16,
                  fieldLabel: EmployeesLabel.E_QUESTION_16
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_58,
                  fieldLabel: EmployeesLabel.E_HEADING_9,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_13,
                    EmployeesKey.E_QUESTION_14
                  ],
                  formula: calculateSum
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_59,
                  fieldLabel: EmployeesLabel.E_HEADING_10,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_15,
                    EmployeesKey.E_QUESTION_16
                  ],
                  formula: calculateSum
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_60,
                  fieldLabel: EmployeesLabel.E_HEADING_11,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_13,
                    EmployeesKey.E_QUESTION_14,
                    EmployeesKey.E_QUESTION_15,
                    EmployeesKey.E_QUESTION_16
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const totalEmployees = totalMale + totalFemale;
                    const permanent = permaMale + permaFemale;

                    return totalEmployees - permanent;
                  }
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_61,
                  fieldLabel: EmployeesLabel.E_HEADING_12,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_15,
                    EmployeesKey.E_QUESTION_16
                  ],
                  formula: ([permaMale, permaFemale]: any[]):
                    | number
                    | string => {
                    return (permaMale / (permaMale + permaFemale)) * 100 || 0;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_62,
                  fieldLabel: EmployeesLabel.E_HEADING_13,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_15,
                    EmployeesKey.E_QUESTION_16
                  ],
                  formula: ([permaMale, permaFemale]: any[]):
                    | number
                    | string => {
                    return (permaFemale / (permaMale + permaFemale)) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_90,
                  fieldLabel: EmployeesLabel.E_HEADING_28,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_13,
                    EmployeesKey.E_QUESTION_15
                  ],
                  formula: ([totalMale, permaMale]: any[]): number | string => {
                    return totalMale - permaMale;
                  }
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_91,
                  fieldLabel: EmployeesLabel.E_HEADING_29,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_14,
                    EmployeesKey.E_QUESTION_16
                  ],
                  formula: ([totalFemale, permaFemale]: any[]):
                    | number
                    | string => {
                    return totalFemale - permaFemale;
                  }
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_92,
                  fieldLabel: EmployeesLabel.E_HEADING_30,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_13,
                    EmployeesKey.E_QUESTION_14,
                    EmployeesKey.E_QUESTION_15,
                    EmployeesKey.E_QUESTION_16
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const otherMale = totalMale - permaMale;
                    const otherFemale = totalFemale - permaFemale;
                    const totalOther = otherMale + otherFemale;

                    return (otherMale / totalOther) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_93,
                  fieldLabel: EmployeesLabel.E_HEADING_31,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_13,
                    EmployeesKey.E_QUESTION_14,
                    EmployeesKey.E_QUESTION_15,
                    EmployeesKey.E_QUESTION_16
                  ],
                  formula: ([
                    totalMale,
                    totalFemale,
                    permaMale,
                    permaFemale
                  ]: any[]): number | string => {
                    const otherMale = totalMale - permaMale;
                    const otherFemale = totalFemale - permaFemale;
                    const totalOther = otherMale + otherFemale;

                    return (otherFemale / totalOther) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_94,
                  fieldLabel: EmployeesLabel.E_HEADING_32,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_13,
                    EmployeesKey.E_QUESTION_14
                  ],
                  formula: ([totalMale, totalFemale]: any[]):
                    | number
                    | string => {
                    const total = totalMale + totalFemale;

                    return (totalMale / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_95,
                  fieldLabel: EmployeesLabel.E_HEADING_33,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_13,
                    EmployeesKey.E_QUESTION_14
                  ],
                  formula: ([totalMale, totalFemale]: any[]):
                    | number
                    | string => {
                    const total = totalMale + totalFemale;

                    return (totalFemale / total) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: EmployeesLabel.E_HEADINGLABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_17,
                  fieldLabel: EmployeesLabel.E_QUESTION_17
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_18,
                  fieldLabel: EmployeesLabel.E_QUESTION_18
                },

                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_19,
                  fieldLabel: EmployeesLabel.E_QUESTION_19
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_20,
                  fieldLabel: EmployeesLabel.E_QUESTION_20
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_63,
                  fieldLabel: EmployeesLabel.E_HEADING_17,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_17,
                    EmployeesKey.E_QUESTION_18
                  ],
                  formula: ([totalBOD, noFemale]: any[]): number | string => {
                    return (noFemale / totalBOD) * 100 || 0;
                  },
                  units: Units.percentage
                },

                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_64,
                  fieldLabel: EmployeesLabel.E_HEADING_18,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_19,
                    EmployeesKey.E_QUESTION_20
                  ],
                  formula: ([totalKMP, noFemale]: any[]): number | string => {
                    return (noFemale / totalKMP) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: EmployeesLabel.E_HEADINGLABEL_3,
    items: [
      {
        field: [
          {
            fieldType: inputType.HEADING_3,
            heading: EmployeesLabel.E_HEADING_4
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: EmployeesLabel.E_QUESTION_29
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_112,
                  fieldLabel: EmployeesLabel.E_QUESTION_24
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_113,
                  fieldLabel: EmployeesLabel.E_QUESTION_25
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_30,
                  fieldLabel: EmployeesLabel.E_QUESTION_30
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_31,
                  fieldLabel: EmployeesLabel.E_QUESTION_31
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_67,
                  fieldLabel: EmployeesLabel.E_HEADING_21,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_30,
                    EmployeesKey.E_QUESTION_31,
                    EmployeesKey.E_QUESTION_112,
                    EmployeesKey.E_QUESTION_113
                  ],

                  formula: ([
                    maleLeft,
                    femaleLeft,
                    totalMale,
                    totalFemale
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const left = maleLeft + femaleLeft;

                    return (left / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_100,
                  fieldLabel: EmployeesLabel.E_HEADING_34,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_30,
                    EmployeesKey.E_QUESTION_112
                  ],

                  formula: ([maleLeft, totalMale]: any[]): number | string => {
                    return (maleLeft / totalMale) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_101,
                  fieldLabel: EmployeesLabel.E_HEADING_35,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_31,
                    EmployeesKey.E_QUESTION_113
                  ],
                  formula: ([femaleLeft, totalFemale]: any[]):
                    | number
                    | string => {
                    return (femaleLeft / totalFemale) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: EmployeesLabel.E_QUESTION_26
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_83,
                  fieldLabel: EmployeesLabel.E_QUESTION_24
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_84,
                  fieldLabel: EmployeesLabel.E_QUESTION_25
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_27,
                  fieldLabel: EmployeesLabel.E_QUESTION_27
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_28,
                  fieldLabel: EmployeesLabel.E_QUESTION_28
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_66,
                  fieldLabel: EmployeesLabel.E_HEADING_20,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_27,
                    EmployeesKey.E_QUESTION_28,
                    EmployeesKey.E_QUESTION_83,
                    EmployeesKey.E_QUESTION_84
                  ],

                  formula: ([
                    maleLeft,
                    femaleLeft,
                    totalMale,
                    totalFemale
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const left = maleLeft + femaleLeft;

                    return (left / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_102,
                  fieldLabel: EmployeesLabel.E_HEADING_36,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_27,
                    EmployeesKey.E_QUESTION_83
                  ],

                  formula: ([maleLeft, totalMale]: any[]): number | string => {
                    return (maleLeft / totalMale) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_103,
                  fieldLabel: EmployeesLabel.E_HEADING_37,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_28,
                    EmployeesKey.E_QUESTION_84
                  ],
                  formula: ([femaleLeft, totalFemale]: any[]):
                    | number
                    | string => {
                    return (femaleLeft / totalFemale) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: EmployeesLabel.E_QUESTION_21
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_24,
                  fieldLabel: EmployeesLabel.E_QUESTION_24
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_25,
                  fieldLabel: EmployeesLabel.E_QUESTION_25
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_22,
                  fieldLabel: EmployeesLabel.E_QUESTION_22
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_23,
                  fieldLabel: EmployeesLabel.E_QUESTION_23
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_65,
                  fieldLabel: EmployeesLabel.E_HEADING_19,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_22,
                    EmployeesKey.E_QUESTION_23,
                    EmployeesKey.E_QUESTION_24,
                    EmployeesKey.E_QUESTION_25
                  ],

                  formula: ([
                    maleLeft,
                    femaleLeft,
                    totalMale,
                    totalFemale
                  ]: any[]): number | string => {
                    const left = maleLeft + femaleLeft;
                    const total = totalMale + totalFemale;

                    return (left / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_104,
                  fieldLabel: EmployeesLabel.E_HEADING_38,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_22,
                    EmployeesKey.E_QUESTION_24
                  ],

                  formula: ([maleLeft, totalMale]: any[]): number | string => {
                    return (maleLeft / totalMale) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_105,
                  fieldLabel: EmployeesLabel.E_HEADING_39,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_23,
                    EmployeesKey.E_QUESTION_25
                  ],
                  formula: ([femaleLeft, totalFemale]: any[]):
                    | number
                    | string => {
                    return (femaleLeft / totalFemale) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING_3,
            heading: EmployeesLabel.E_HEADING_10
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: EmployeesLabel.E_QUESTION_40
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_114,
                  fieldLabel: EmployeesLabel.E_QUESTION_35
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_115,
                  fieldLabel: EmployeesLabel.E_QUESTION_36
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_41,
                  fieldLabel: EmployeesLabel.E_QUESTION_41
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_42,
                  fieldLabel: EmployeesLabel.E_QUESTION_42
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_70,
                  fieldLabel: EmployeesLabel.E_HEADING_21,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_41,
                    EmployeesKey.E_QUESTION_42,
                    EmployeesKey.E_QUESTION_114,
                    EmployeesKey.E_QUESTION_115
                  ],

                  formula: ([
                    maleLeft,
                    femaleLeft,
                    totalMale,
                    totalFemale
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const left = maleLeft + femaleLeft;

                    return (left / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_106,
                  fieldLabel: EmployeesLabel.E_HEADING_34,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_41,
                    EmployeesKey.E_QUESTION_114
                  ],

                  formula: ([maleLeft, totalMale]: any[]): number | string => {
                    return (maleLeft / totalMale) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_107,
                  fieldLabel: EmployeesLabel.E_HEADING_35,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_42,
                    EmployeesKey.E_QUESTION_115
                  ],
                  formula: ([femaleLeft, totalFemale]: any[]):
                    | number
                    | string => {
                    return (femaleLeft / totalFemale) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: EmployeesLabel.E_QUESTION_37
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_85,
                  fieldLabel: EmployeesLabel.E_QUESTION_35
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_86,
                  fieldLabel: EmployeesLabel.E_QUESTION_36
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_38,
                  fieldLabel: EmployeesLabel.E_QUESTION_38
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_39,
                  fieldLabel: EmployeesLabel.E_QUESTION_39
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_69,
                  fieldLabel: EmployeesLabel.E_HEADING_20,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_38,
                    EmployeesKey.E_QUESTION_39,
                    EmployeesKey.E_QUESTION_85,
                    EmployeesKey.E_QUESTION_86
                  ],

                  formula: ([
                    maleLeft,
                    femaleLeft,
                    totalMale,
                    totalFemale
                  ]: any[]): number | string => {
                    const total = totalMale + totalFemale;
                    const left = maleLeft + femaleLeft;

                    return (left / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_108,
                  fieldLabel: EmployeesLabel.E_HEADING_36,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_38,
                    EmployeesKey.E_QUESTION_85
                  ],

                  formula: ([maleLeft, totalMale]: any[]): number | string => {
                    return (maleLeft / totalMale) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_109,
                  fieldLabel: EmployeesLabel.E_HEADING_37,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_39,
                    EmployeesKey.E_QUESTION_86
                  ],
                  formula: ([femaleLeft, totalFemale]: any[]):
                    | number
                    | string => {
                    return (femaleLeft / totalFemale) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          },
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_3,
                  heading: EmployeesLabel.E_QUESTION_32
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_35,
                  fieldLabel: EmployeesLabel.E_QUESTION_35
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_36,
                  fieldLabel: EmployeesLabel.E_QUESTION_36
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_33,
                  fieldLabel: EmployeesLabel.E_QUESTION_33
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName: EmployeesKey.E_QUESTION_34,
                  fieldLabel: EmployeesLabel.E_QUESTION_34
                }
              ],
              formCalculations: [
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_68,
                  fieldLabel: EmployeesLabel.E_HEADING_19,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_33,
                    EmployeesKey.E_QUESTION_34,
                    EmployeesKey.E_QUESTION_35,
                    EmployeesKey.E_QUESTION_36
                  ],

                  formula: ([
                    maleLeft,
                    femaleLeft,
                    totalMale,
                    totalFemale
                  ]: any[]): number | string => {
                    const left = maleLeft + femaleLeft;
                    const total = totalMale + totalFemale;

                    return (left / total) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_110,
                  fieldLabel: EmployeesLabel.E_HEADING_38,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_33,
                    EmployeesKey.E_QUESTION_35
                  ],

                  formula: ([maleLeft, totalMale]: any[]): number | string => {
                    return (maleLeft / totalMale) * 100 || 0;
                  },
                  units: Units.percentage
                },
                {
                  type: inputType.DISPLAY,
                  fieldName: EmployeesKey.E_QUESTION_111,
                  fieldLabel: EmployeesLabel.E_HEADING_39,
                  relatedKey: [
                    EmployeesKey.E_QUESTION_34,
                    EmployeesKey.E_QUESTION_36
                  ],
                  formula: ([femaleLeft, totalFemale]: any[]):
                    | number
                    | string => {
                    return (femaleLeft / totalFemale) * 100 || 0;
                  },
                  units: Units.percentage
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const holdingSubsidiaryAndAssociateCompaniesTabQuestions = [
  {
    key: '1',
    label: HoldingSubsidiaryAndAssociateCompaniesLabel.HSAAC_HEADINGLABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              HoldingSubsidiaryAndAssociateCompaniesKey.HSAAC_QUESTION_11,
            formList: {
              formFields: [
                {
                  type: inputType.TEXT,
                  fieldName:
                    HoldingSubsidiaryAndAssociateCompaniesKey.HSAAC_QUESTION_1,
                  fieldLabel:
                    HoldingSubsidiaryAndAssociateCompaniesLabel.HSAAC_HEADING_1,
                  placeHolder:
                    'Name of the holding / subsidiary / associate companies / joint ventures (A)',
                  colSpan: true
                },
                {
                  type: inputType.SELECT,
                  fieldName:
                    HoldingSubsidiaryAndAssociateCompaniesKey.HSAAC_QUESTION_2,
                  fieldLabel:
                    HoldingSubsidiaryAndAssociateCompaniesLabel.HSAAC_HEADING_2,
                  options: [
                    {label: 'Subsidiary', value: 'Subsidiary'},
                    {label: 'Associate', value: 'Associate'},
                    {label: 'Joint Venture', value: 'Joint Venture'}
                  ],
                  placeHolder:
                    'Indicate whether holding / Subsidiary / Associate / Joint Venture',
                  colSpan: true
                },
                {
                  type: inputType.PERCENTAGE,
                  fieldName:
                    HoldingSubsidiaryAndAssociateCompaniesKey.HSAAC_QUESTION_3,
                  fieldLabel:
                    HoldingSubsidiaryAndAssociateCompaniesLabel.HSAAC_HEADING_3,
                  placeHolder: '% of shares held by listed entity',
                  units: Units.percentage,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    HoldingSubsidiaryAndAssociateCompaniesKey.HSAAC_QUESTION_4,
                  fieldLabel:
                    HoldingSubsidiaryAndAssociateCompaniesLabel.HSAAC_HEADING_4,
                  options: ['Yes', 'No'],
                  placeHolder:
                    'Does the entity indicated at column A, participate in the Business Responsibility initiatives of the listed entity? (Yes/No)',
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];

export const CSRDetailsTabQuestions = [
  {
    key: '1',
    items: [
      {
        question: '',
        field: [
          {
            fieldType: inputType.RADIOGROUP,
            fieldName: CSRDetailsKey.CSRD_QUESTION_1,
            fieldLabel: CSRDetailsLabel.CSRD_HEADING_1,
            heading: inputType.HEADING,
            options: ['Yes', 'No'],
            colSpan: true
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: CSRDetailsKey.CSRD_QUESTION_1_yes,
            fieldLabel: CSRDetailsLabel.CSRD_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: CSRDetailsKey.CSRD_QUESTION_2,
            fieldLabel: CSRDetailsLabel.CSRD_HEADING_2,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: CSRDetailsKey.CSRD_QUESTION_3,
            fieldLabel: CSRDetailsLabel.CSRD_HEADING_3,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  }
];

export const transparencyAndDisclosuresCompliancesTabQuestions = [
  {
    key: '1',
    label: TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_LABEL_1,
    items: [
      {
        field: [
          {
            fieldType: inputType.INPUT_GRID,
            formContent: {
              formFields: [
                {
                  type: inputType.HEADING_2,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_1
                },
                {
                  type: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_1,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_10,
                  options: ['Yes', 'No'],
                  placeHolder: 'Web-link for grievance redress',
                  colSpan: true
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_2,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_3,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_4,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_5,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_6,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_7,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING_2,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_4
                },
                {
                  type: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_8,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_10,
                  options: ['Yes', 'No'],
                  placeHolder: 'Web-link for grievance redress',
                  colSpan: true
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_9,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_10,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_11,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_12,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_13,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_14,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING_2,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_5
                },
                {
                  type: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_15,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_10,
                  options: ['Yes', 'No'],
                  placeHolder: 'Web-link for grievance redress',
                  colSpan: true
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_16,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_17,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_18,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_19,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_20,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_21,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING_2,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_9
                },
                {
                  type: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_42,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_10,
                  options: ['Yes', 'No'],
                  placeHolder: 'Web-link for grievance redress',
                  colSpan: true
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_43,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_44,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_45,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_46,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_47,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_48,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING_2,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_10
                },
                {
                  type: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_49,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_10,
                  options: ['Yes', 'No'],
                  placeHolder: 'Web-link for grievance redress',
                  colSpan: true
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_50,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_51,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_52,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_53,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_54,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_55,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING_2,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_6
                },
                {
                  type: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_41,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_10,
                  options: ['Yes', 'No'],
                  placeHolder: 'Web-link for grievance redress',
                  colSpan: true
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_22,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_23,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_24,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_25,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_26,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_27,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING_2,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_7
                },
                {
                  type: inputType.RADIOGROUP_IF_YES_THEN_TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_28,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_10,
                  options: ['Yes', 'No'],
                  placeHolder: 'Web-link for grievance redress',
                  colSpan: true
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_29,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_30,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_31,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                },
                {
                  type: inputType.HEADING,
                  heading:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_3
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_32,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_2
                },
                {
                  type: inputType.NUMBER_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_33,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_3
                },
                {
                  type: inputType.TEXTAREA_COL,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_34,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_4,
                  askAIkey: 'TDC_COMPLAINTS_P1_9'
                }
              ]
            }
          }
        ]
      }
    ]
  },

  {
    key: '2',
    label: TransparencyAndDisclosuresCompliancesLabel.TADC_HEADING_LABEL_2,
    items: [
      {
        field: [
          {
            fieldType: inputType.ADD_NEW_TO_TABLE,
            fieldName:
              TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_40,
            formList: {
              formFields: [
                {
                  type: inputType.TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_35,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_5,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_36,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_6,
                  options: ['Risk', 'Opportunity', 'Risk/Opportunity'],
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_37,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_7,
                  colSpan: true
                },
                {
                  type: inputType.TEXTAREA,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_38,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_8,
                  colSpan: true
                },
                {
                  type: inputType.RADIOGROUP,
                  fieldName:
                    TransparencyAndDisclosuresCompliancesKey.TADC_QUESTION_39,
                  fieldLabel:
                    TransparencyAndDisclosuresCompliancesLabel.TADC_QUESTION_9,
                  options: ['Positive', 'Negative'],
                  colSpan: true
                }
              ]
            }
          }
        ]
      }
    ]
  }
];
